import { MapPin, ChevronRight } from "lucide-react";
import { PILStatusChip } from "./PILStatusChip";
import { DirectionsLink } from "./DirectionsLink";
import { cn } from "@/lib/utils";

interface LocationListItemProps {
  name: string;
  address?: string | null;
  lat: number;
  lng: number;
  status: string;
  pilCount: number;
  distanceKm?: number | null;
  onClick?: () => void;
  className?: string;
}

export function LocationListItem({
  name,
  address,
  lat,
  lng,
  status,
  pilCount,
  distanceKm,
  onClick,
  className,
}: LocationListItemProps) {
  return (
    <div
      className={cn(
        "flex items-start gap-3 border-b px-4 py-3 active:bg-muted/60 transition-colors cursor-pointer",
        className,
      )}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onClick?.();
        }
      }}
    >
      <div className="shrink-0 pt-1">
        <MapPin className="h-5 w-5 text-muted-foreground" />
      </div>

      <div className="min-w-0 flex-1 space-y-1">
        <div className="flex items-start justify-between gap-2">
          <h3 className="font-medium text-sm leading-tight truncate">{name}</h3>
          <ChevronRight className="h-4 w-4 shrink-0 text-muted-foreground mt-0.5" />
        </div>

        {address && (
          <p className="text-xs text-muted-foreground truncate">{address}</p>
        )}

        <div className="flex flex-wrap items-center gap-2 pt-1">
          <PILStatusChip status={status} />
          <span className="text-xs text-muted-foreground">
            {pilCount} spot{pilCount === 1 ? "" : "s"}
          </span>
          {distanceKm != null && (
            <span className="text-xs text-muted-foreground">
              · {distanceKm < 1 ? `${Math.round(distanceKm * 1000)} m` : `${distanceKm.toFixed(1)} km`}
            </span>
          )}
        </div>

        <div className="pt-2">
          <DirectionsLink lat={lat} lng={lng} name={name} />
        </div>
      </div>
    </div>
  );
}
